import React from "react";
import { ArrowRight } from "lucide-react";

export default function CTA({ onDemoClick }) {
  return (
    <section
      data-testid="cta-section"
      className="relative py-28 md:py-40 overflow-hidden"
    >
      <div className="pointer-events-none absolute inset-0 grid-bg opacity-60" />
      <div className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[500px] glow-purple opacity-50" />

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative text-center">
        <h2
          data-testid="cta-headline"
          className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight text-white"
        >
          Your next hire is{" "}
          <span className="italic text-white/90">already trained</span>
          <span className="text-[#7C5CFF]">.</span>
        </h2>
        <p className="mt-8 text-white/60 text-lg md:text-xl max-w-2xl mx-auto">
          Deploy an AI agent that actually understands your customers — in
          under an afternoon. No RFP. No six-month pilot.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          <button
            data-testid="cta-primary-btn"
            onClick={onDemoClick}
            className="btn-primary text-white text-[15px] font-medium pl-6 pr-5 py-3 rounded-full inline-flex items-center gap-2"
          >
            Request a demo
            <ArrowRight className="w-4 h-4" />
          </button>
          <a
            href="#pricing"
            data-testid="cta-secondary-btn"
            className="btn-ghost text-white text-[15px] font-medium px-6 py-3 rounded-full"
          >
            Explore pricing
          </a>
        </div>

        <div className="mt-12 inline-flex items-center gap-2 text-[11px] font-mono tracking-[0.2em] uppercase text-white/40">
          <span className="w-1.5 h-1.5 rounded-full bg-[#3DDFB3] soft-pulse" />
          14-day free trial · No credit card required
        </div>
      </div>
    </section>
  );
}
